import { featuresData } from '@/mocks/comicData';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {featuresData.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-100">
                <i className={`${item.icon} text-accent-600 text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}